import { getBaseUrl, request } from 'src/helper/api';
import type { ViewTypes } from 'src/helper/shared-types';

export const fetchAllViews = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/views/fetch-all`,
      contentType: 'json',
      token,
      signal,
    },
    'list-view/fetchAllViews',
  );

export const getViewList = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/views`,
      contentType: 'json',
      token,
      signal,
    },
    'list-view/getViewList',
  );

export const getViewDetails = (
  token?: string,
  viewId?: string,
  viewType?: ViewTypes,
  signal?: AbortSignal,
) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/views/config/${viewId}?view_type=${viewType}`,
      contentType: 'json',
      token,
      signal,
    },
    'list-view/getViewDetails',
  );

export const getSelectedGroupByDetails = (
  token?: string,
  viewType?: string,
  signal?: AbortSignal,
) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/${viewType}/group-view`,
      contentType: 'json',
      token,
      signal,
    },
    'list-view/getSelectedGroupByDetails',
  );

export const getSelectedGroupByDetailsForUpdate = (
  token?: string,
  viewType?: string,
  signal?: AbortSignal,
) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/${viewType}/group-view`,
      contentType: 'json',
      token,
      signal,
    },
    'list-view/getSelectedGroupByDetailsForUpdate',
  );

export const getFilterFieldValues = (token?: string, viewType?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/${viewType}/filter`,
      contentType: 'json',
      token,
      signal,
    },
    'list-view/getFilterFieldValues',
  );

export const addNewView = (params?: string, token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/views/store?view_type=${params}`,
      contentType: 'json',
      token,
      signal,
    },
    'list-view/addNewViewList',
  );

export const deleteViewItemFromList = (
  params?: string,
  viewId?: string,
  token?: string,
  signal?: AbortSignal,
) =>
  request(
    {
      method: 'DELETE',
      url: `${getBaseUrl()}api/views/${viewId}/delete?view_type=${params}`,
      contentType: 'json',
      token,
      signal,
    },
    'list-view/deleteViewItemFromList',
  );

export const setAsDefaultView = (
  params?: string,
  viewId?: string,
  token?: string,
  signal?: AbortSignal,
) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/views/${viewId}/set-as-default?view_type=${params}`,
      contentType: 'json',
      token,
      signal,
    },
    'list-view/setAsDefaultView',
  );

export const pinView = (params?: string, viewId?: string, token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/views/${viewId}/pin?view_type=${params}`,
      contentType: 'json',
      token,
      signal,
    },
    'list-view/pinView',
  );

export const duplicateView = (
  params?: string,
  viewId?: string,
  token?: string,
  signal?: AbortSignal,
) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/views/${viewId}/duplicate?view_type=${params}`,
      contentType: 'json',
      token,
      signal,
    },
    'list-view/duplicateView',
  );

export const renameView = (
  params?: string,
  viewId?: string,
  token?: string,
  signal?: AbortSignal,
) =>
  request(
    {
      method: 'PATCH',
      url: `${getBaseUrl()}api/views/${viewId}/rename?view_type=${params}`,
      contentType: 'json',
      token,
      signal,
    },
    'list-view/renameView',
  );

export const updateView = (
  params?: string,
  viewId?: string,
  token?: string,
  signal?: AbortSignal,
) =>
  request(
    {
      method: 'PATCH',
      url: `${getBaseUrl()}api/views/${viewId}/update?view_type=${params}`,
      contentType: 'json',
      token,
      signal,
    },
    'list-view/updateView',
  );
